import type { MaasWorkload } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';
import { type ModelCapabilityModalityKey, normalizeModelCapabilityKeys } from '@/types/model-capabilities';

/** 模型类型表单字段（提交写入 spec.model.types） */
export const MODEL_CATEGORY_FORM_FIELD = '_modelCategory';

export function normalizeModelCategory(value: unknown): ModelCapabilityModalityKey[] {
  return normalizeModelCapabilityKeys(value);
}

export function hasModelCategory(value: unknown): boolean {
  return normalizeModelCategory(value).length > 0;
}

/** 从 workload 读取模型类型（spec.model.types） */
export function getModelCategoryFromWorkload(record?: MaasWorkload | null): ModelCapabilityModalityKey[] {
  if (!record) return [];
  const model = (record.spec as { model?: { types?: unknown } } | undefined)?.model;
  return normalizeModelCategory(model?.types);
}
